import axios from "axios";
import { BASE_URL } from "../constant/apiUrl";
import { clearAuthStorage, isLoginRoute } from "../utils/deactivatedUserSession";

const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("auth_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    const errorDetails = {
      message: error.message || "Request configuration failed",
      config: error.config,
      code: error.code || "UNKNOWN_ERROR",
    };
    console.error("Request interceptor error:", errorDetails);

    return Promise.reject(new Error(JSON.stringify(errorDetails)));
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;

    if (error?.response && (status === 401 || status === 403) && isLoginRoute()) {
      clearAuthStorage();
    }

    const errorDetails = {
      message: error.message || "Response error",
      status: error.response?.status,
      data: error.response?.data,
      config: error.config,
    };
    console.error("Response interceptor error:", errorDetails);

    return Promise.reject(new Error(JSON.stringify(errorDetails)));
  }
);

export default api;
